export function getSocial(component) {
  const { instagram, facebook, youtube, twitter, linkedin } = component;
  const social = {};

  if (instagram) {
    social.instagram = {
      name: "Instagram",
      link: instagram,
      icon: "fab fa-instagram",
      size: 20,
    };
  }

  if (facebook) {
    social.facebook = {
      name: "Facebook",
      link: facebook,
      icon: "fab fa-facebook-f",
      size: 20,
    };
  }

  if (youtube) {
    social.youtube = {
      name: "Youtube",
      link: youtube,
      icon: "fab fa-youtube",
      size: 20,
    };
  }

  if (twitter) {
    social.twitter = {
      name: "Twitter",
      link: twitter,
      icon: "fab fa-twitter",
      size: 20,
    };
  }

  if (linkedin) {
    social.linkedin = {
      name: "Linkedin",
      link: linkedin,
      icon: "fab fa-linkedin",
      size: 20,
    };
  }

  return social;
}
